// component/AddSchedulerPopup.js
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Actions from '../Redux/action';

export const AddEmailSchedulerPopup = ({ onClose, data, onSuccess }) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        name: '',
        scheduled_times: [''],
        subject: '',
        message: '',
        recipient_list: '',
        receiver: '',
        is_active: true
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (data) {
            const recipientList = Array.isArray(data.recipient_list) 
                ? data.recipient_list.join(', ') 
                : data.recipient_list || '';
            
            setFormData({
                name: data.name || '',
                scheduled_times: data.scheduled_times || [''],
                subject: data.subject || '',
                message: data.message || '',
                recipient_list: recipientList,
                receiver: data.receiver || '',
                is_active: data.is_active !== undefined ? data.is_active : true
            });
        }
    }, [data]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const handleTimeChange = (index, value) => {
        const newTimes = [...formData.scheduled_times];
        newTimes[index] = value;
        setFormData(prev => ({
            ...prev,
            scheduled_times: newTimes
        }));
    };

    const addTimeSlot = () => {
        setFormData(prev => ({
            ...prev,
            scheduled_times: [...prev.scheduled_times, '']
        }));
    };
    const toggleActiveStatus = () => {
        setFormData(prev => ({
            ...prev,
            is_active: !prev.is_active
        }));
    };
    const removeTimeSlot = (index) => {
        if (formData.scheduled_times.length > 1) {
            const newTimes = [...formData.scheduled_times];
            newTimes.splice(index, 1);
            setFormData(prev => ({
                ...prev,
                scheduled_times: newTimes
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.name.trim()) {
            newErrors.name = 'Schedule name is required';
        }
        
        if (!formData.scheduled_times.some(time => time.trim())) {
            newErrors.scheduled_times = 'At least one scheduled time is required';
        }
        
        if (!formData.subject.trim()) {
            newErrors.subject = 'Email subject is required';
        }
        
        if (!formData.message.trim()) {
            newErrors.message = 'Email message is required';
        }
        
        if (!formData.recipient_list || !String(formData.recipient_list).trim()) {
            newErrors.recipient_list = 'Recipient list is required';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
const handleSubmit = (e) => {
  e.preventDefault();
  
  if (!validateForm()) return;

  const filteredTimes = formData.scheduled_times
    .filter(time => time.trim())
    .map(time => {
      if (time.includes(':')) {
        const parts = time.split(':');
        const hours = parts[0].padStart(2, '0');
        const minutes = parts[1] ? parts[1].padStart(2, '0') : '00';
        return `${hours}:${minutes}`;
      }
      return time;
    });
  
        const recipientArray = String(formData.recipient_list)
            .split(',')
            .map(email => email.trim())
            .filter(email => email.length > 0);
  
  const scheduleData = {
    ...formData,
    scheduled_times: filteredTimes,
    recipient_list: recipientArray
  };

  
  dispatch(Actions.updateEmailSchedule(scheduleData));
  onSuccess();
};

    return (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {data ? 'Edit Schedule' : 'Add New Schedule'}
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            {/* Schedule Name */}
                            <div className="mb-3">
                                <label className="form-label">Schedule Name <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    placeholder="Enter schedule name"
                                    disabled={!!data} // Name cannot be changed for existing schedules
                                />
                                {errors.name && (
                                    <div className="invalid-feedback">{errors.name}</div>
                                )}
                            </div>
                            <div className="mb-3">
                                <label className="form-label d-block">Schedule Status</label>
                                <div className="btn-group" role="group">
                                    <button
                                        type="button"
                                        className={`btn ${formData.is_active ? "btn-primary" : "btn-outline-primary"}`}
                                        onClick={toggleActiveStatus}
                                    >
                                        Active
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn ${!formData.is_active ? "btn-primary" : "btn-outline-primary"}`}
                                        onClick={toggleActiveStatus}
                                    >
                                        Inactive
                                    </button>
                                </div>
                                <div className="mt-2">
                                    <span className={`badge ${formData.is_active ? "btn-primary" : "btn-outline-primary"}`}>
                                        {formData.is_active ? '✓ Active - Emails will be sent' : '✗ Inactive - Emails paused'}
                                    </span>
                                </div>
                            </div>
                            {/* Scheduled Times */}
                            <div className="mb-3">
                                <label className="form-label">Scheduled Times (HH:mm) <span className="text-danger">*</span></label>
                                {formData.scheduled_times.map((time, index) => (
                                    <div key={index} className="input-group mb-2">
                                        <input
                                            type="time"
                                            className={`form-control ${errors.scheduled_times ? 'is-invalid' : ''}`}
                                            value={time}
                                            onChange={(e) => handleTimeChange(index, e.target.value)}
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger"
                                            onClick={() => removeTimeSlot(index)}
                                            disabled={formData.scheduled_times.length === 1}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                ))}
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={addTimeSlot}
                                >
                                    Add Another Time
                                </button>
                                {errors.scheduled_times && (
                                    <div className="text-danger small mt-1">{errors.scheduled_times}</div>
                                )}
                            </div>

                            {/* Email Subject */}
                            <div className="mb-3">
                                <label className="form-label">Email Subject <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.subject ? 'is-invalid' : ''}`}
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleInputChange}
                                    placeholder="Email subject"
                                />
                                {errors.subject && (
                                    <div className="invalid-feedback">{errors.subject}</div>
                                )}
                            </div>

                            {/* Email Message */}
                            <div className="mb-3">
                                <label className="form-label">Email Message <span className="text-danger">*</span></label>
                                <textarea
                                    className={`form-control ${errors.message ? 'is-invalid' : ''}`}
                                    name="message"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    placeholder="Email message"
                                    rows="4"
                                />
                                {errors.message && (
                                    <div className="invalid-feedback">{errors.message}</div>
                                )}
                            </div>

                            {/* Recipient List */}
                            <div className="mb-3">
                                <label className="form-label">Recipient List (comma-separated emails) <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.recipient_list ? 'is-invalid' : ''}`}
                                    name="recipient_list"
                                    value={formData.recipient_list}
                                    onChange={handleInputChange}
                                    placeholder="email1@example.com, email2@example.com"
                                />
                                {errors.recipient_list && (
                                    <div className="invalid-feedback">{errors.recipient_list}</div>
                                )}
                            </div>

                            {/* Receiver */}
                            <div className="mb-3">
                                <label className="form-label">Receiver</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="receiver"
                                    value={formData.receiver}
                                    onChange={handleInputChange}
                                    placeholder="Receiver name"
                                />
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={onClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                >
                                    {data ? 'Update Schedule' : 'Create Schedule'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};